import api from './api';

// Serviço compartilhado para relatórios fixos ou dinâmicos que retornam PDF por job.
export async function baixarRelatorio(endpoint, parametros, nomePadrao = 'relatorio.pdf') {
  try {
    const response = await api.post(endpoint, parametros, {
      responseType: 'blob', timeout: 180000, headers: { Accept: 'application/pdf' }
    });
    if (!(response.headers['content-type'] || '').includes('application/pdf')) {
      let retorno;
      try { retorno = JSON.parse(await response.data.text()); } catch (_) { /* resposta inesperada */ }
      throw new Error(retorno?.message || retorno?.error || 'O servidor não retornou um PDF válido.');
    }
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="([^"]+)"|filename=([^;]+)/i);
    let nome = nomePadrao;
    if (match) {
      try { nome = decodeURIComponent(match[1] || match[2] || match[3]).replace(/[\\/]/g, '_'); } catch (_) { /* usa padrão */ }
    }
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url; link.download = nome;
    document.body.appendChild(link); link.click(); link.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return response.headers['x-report-job-id'] || null;
  } catch (error) {
    let dados = error.response?.data;
    if (dados instanceof Blob) {
      try { dados = JSON.parse(await dados.text()); } catch (_) { dados = null; }
    }
    throw new Error(dados?.message || dados?.error || (error.code === 'ECONNABORTED'
      ? 'Tempo de espera excedido. Verifique a geração do relatório antes de tentar novamente.'
      : error.message || 'Não foi possível baixar o relatório.'));
  }
}
